import type { ComponentProps } from "react";

type ChipVariant = "default" | "ok" | "bad" | "info" | "blue" | "warn";

const VARIANT_CLASSES: Record<ChipVariant, string> = {
  default: "text-rs-light-gray border-rs-jet-light",
  ok: "text-rs-green border-rs-green/35 bg-rs-green/8",
  bad: "text-rs-red border-rs-red/40 bg-rs-red/9",
  info: "text-rs-light-purple border-rs-purple/40 bg-rs-purple/9",
  blue: "text-rs-blue border-rs-blue/40 bg-rs-blue/9",
  warn: "text-rs-amber border-rs-amber/45 bg-rs-amber/9",
};

interface ChipProps extends ComponentProps<"span"> {
  variant?: ChipVariant;
}

export function Chip({ variant = "default", className = "", ...props }: ChipProps) {
  return (
    <span
      className={`inline-flex items-center gap-[5px] text-[11.5px] px-2 py-0.5 rounded-[3px] border ${VARIANT_CLASSES[variant]} ${className}`}
      {...props}
    />
  );
}
